import { useContext } from 'react';
import { DataContext } from './DataContext';

const AppData: any = () => {
    const {
       
        appLoggedIn,
        appLoggedInChange,
    } = useContext(DataContext);

    return null;
};

export default AppData;
